import 'core-js/modules/es.regexp.flags.js';
import 'core-js/modules/es.array.flat-map.js';
import 'core-js/modules/es.array.unscopables.flat-map.js';
import 'core-js/modules/es.string.includes.js';
import get from 'lodash/get';
import gt from 'lodash/gt';
import gte from 'lodash/gte';
import has from 'lodash/has';
import includes from 'lodash/includes';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isNil from 'lodash/isNil';
import lt from 'lodash/lt';
import lte from 'lodash/lte';
import { FLAGS } from '../domain/dtos/flags.js';

class IsFlagEnabled {
  constructor(flags) {
    this.flags = flags;
  }
  isEnabled(flag, data) {
    if (isEmpty(this.flags)) {
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const operators = {
      '==': isEqual,
      '!=': (value, other) => !isEqual(value, other),
      '<=': lte,
      '>': gt,
      '>=': gte,
      '<': lt,
      'array-contains': (value, other) => includes(value, other),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'map-contains': (value, other) => other === null || other === void 0 ? void 0 : other.find(obj => has(obj, value)),
      /**
       * @todo
       */
      'array-contains-any': () => false,
      'not-in': () => false,
      in: (value, other) => includes(other, value)
    };
    const flagByName = this.flags.find(({
      name
    }) => isEqual(flag, name));
    /**
     * @description local fallback to critical flags when remote config does not fetch them
     */
    if (isNil(flagByName) && this.isEnabledByDefault(flag)) {
      return true;
    }
    if (isNil(flagByName)) {
      return false;
    }
    return typeof flagByName.value === 'boolean' ? flagByName.value : !Array.isArray(flagByName.value) ? false : flagByName.value.every(({
      field,
      op,
      value
    }) => {
      const operator = operators[op !== null && op !== void 0 ? op : '=='];
      return operator(get(data, field), value);
    });
  }
  getValue(flag, data) {
    if (isEmpty(this.flags)) {
      return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const operators = {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      'map-contains': (value, other) => {
        var _a;
        return (_a = other === null || other === void 0 ? void 0 : other.find(obj => has(obj, value))) === null || _a === void 0 ? void 0 : _a[value];
      },
      /**
       * @todo
       */
      '==': () => null,
      '!=': () => null,
      '<=': () => null,
      '>': () => null,
      '>=': () => null,
      '<': () => null,
      'array-contains': () => null,
      'array-contains-any': () => null,
      'not-in': () => null,
      in: () => null
    };
    const flagByName = this.flags.find(({
      name
    }) => isEqual(flag, name));
    if (isNil(flagByName)) {
      return null;
    }
    return typeof flagByName.value === 'boolean' ? flagByName.value : !Array.isArray(flagByName.value) ? null : flagByName.value.flatMap(({
      field,
      op,
      value
    }) => {
      var _a;
      const operator = operators[op !== null && op !== void 0 ? op : '=='];
      return (_a = operator(get(data, field), value)) !== null && _a !== void 0 ? _a : [];
    });
  }
  getParams(flag) {
    if (isEmpty(this.flags)) {
      return {};
    }
    const flagByName = this.flags.find(({
      name
    }) => isEqual(flag, name));
    if (isNil(flagByName)) {
      return {};
    }
    return flagByName.params;
  }
  isEnabledByDefault(flag) {
    return [FLAGS.CHECKOUT.IS_BANKSLIP_ENABLED, FLAGS.CHECKOUT.IS_CREDIT_CARD_ENABLED, FLAGS.CHECKOUT.IS_PIX_ENABLED].includes(flag);
  }
}

export { IsFlagEnabled };
